import { render, staticRenderFns } from "./ClaimDeviceForm.vue?vue&type=template&id=bef3deb8&"
import script from "./ClaimDeviceForm.vue?vue&type=script&lang=js&"
export * from "./ClaimDeviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports